import React, { Component } from "react";
import PropTypes from "prop-types";
import { Select, Spin } from "antd";
import { isArray } from "lodash";

class MultiSelect extends Component {
  static propTypes = {
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number]))]),
    onChange: PropTypes.func,
    options: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])), // for hardcoded options
    optionApiCall: PropTypes.func, // for dynamic options, must return promise
    optionRender: PropTypes.func,
    placeholder: PropTypes.string,
    disabled: PropTypes.bool,
    allowClear: PropTypes.bool,
    mode: PropTypes.oneOf(["tags", "multiple", "default"]), // "default" is single mode, "tag" allows user input as option
    tokenSeparators: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
    showSearch: PropTypes.bool,
    displayGroups: PropTypes.bool
  };

  static defaultProps = {
    disabled: false,
    allowClear: true,
    mode: "tags",
    showSearch: true,
    displayGroups: false
  };

  state = {
    options: this.props.options ? this.props.options : [],
    optionsLoading: false
  };

  render() {
    const { options, optionsLoading } = this.state;
    const { value, placeholder, disabled, allowClear, optionApiCall, optionRender, mode, style, tokenSeparators, showSearch, displayGroups } = this.props;
    if (displayGroups) {
      const groupedOptions = {};
      options.forEach((option) => {
        const [key, value] = option.split(" - ");
        if (groupedOptions[key]) groupedOptions[key].push(value);
        else groupedOptions[key] = [value];
      });

      return (
        <Select
          value={mode !== "default" && value && !isArray(value) ? [value] : value}
          placeholder={placeholder}
          onChange={this.onChange}
          mode={mode}
          optionLabelProp="label"
          allowClear={allowClear}
          disabled={disabled}
          onSearch={optionApiCall ? this.updateOptions : undefined}
          onFocus={optionApiCall ? e => this.updateOptions(e.target.value) : undefined}
          notFoundContent={optionsLoading ? <Spin /> : "Not Found"}
          filterOption={optionApiCall === undefined}
          showSearch={showSearch}
          style={style}
          tokenSeparators={tokenSeparators}
        >
          {Object.keys(groupedOptions).map((groupKey) => (
            <Select.OptGroup label={groupKey} key={groupKey}>
              <Select.Option value={`select-all-${groupKey}`} key={`select-all-${groupKey}`}>--- SELECT ALL ---</Select.Option>
              {groupedOptions[groupKey].map((option) => (
                <Select.Option value={option} key={option}>
                  {option}
                </Select.Option>
              ))}
            </Select.OptGroup>
          ))}
        </Select>
      );
    } else {
      // we need to convert single `value` to array in `tags` and `multiple` mode
      return (
        <Select
          value={mode !== "default" && value && !isArray(value) ? [value] : value}
          placeholder={placeholder}
          onChange={this.onChange}
          mode={mode}
          optionLabelProp="label"
          allowClear={allowClear}
          disabled={disabled}
          onSearch={optionApiCall ? this.updateOptions : undefined}
          onFocus={optionApiCall ? e => this.updateOptions(e.target.value) : undefined}
          notFoundContent={optionsLoading ? <Spin /> : "Not Found"}
          filterOption={false}
          showSearch={showSearch}
          style={style}
          tokenSeparators={tokenSeparators}
        >
          {options.map((v, i) => {
            const label = optionRender ? optionRender(v) : v;
            return (
              <Select.Option value={v} key={i} label={label}>
                {label}
              </Select.Option>
            );
          })}
        </Select>
      );
    }
  }

  onChange = value => {
    const { onChange } = this.props;
    if (onChange) {
      onChange(value);
    }
  };

  updateOptions = input => {
    const { optionApiCall } = this.props;
    this.setState({
      optionsLoading: true
    });
    // only run when user finish typing
    window.clearTimeout(this._timeout);
    this._timeout = window.setTimeout(() => {
      optionApiCall(input || "") // empty string handle click-but-no-input scenario
        .then(json => {
          this.setState({
            options: json,
            optionsLoading: false
          });
        })
        .catch(() =>
          this.setState({
            options: [],
            optionsLoading: false
          })
        );
    }, 500);
  };
}

export default MultiSelect;
